import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const listDeviceAuth = {
  name: "listDeviceAuth" as const,
  input: z.object({}),
  output: z.object({
    devices: z.array(
      z.object({
        id: z.string(),
        deviceName: z.string(),
        lastUsedAt: zExt.instant(),
        createdAt: zExt.instant(),
        createdBy: z.string(),
        createdByName: z.string().nullish(),
        lastIpAddress: z.string().nullish(),
        creationIpAddress: z.string().nullish(),
        userAgent: z.string().nullish(),
        isActive: z.boolean(),
      }),
    ),
  }),
};
